/**
 * Prevents visible scroll jumps when overlays lock/unlock body scroll.
 * Root cause: html { scroll-behavior: smooth } makes unlock scrollTo() /
 * jQuery scrollTop() animate from 0 back to the saved position.
 *
 * Covers:
 * - Theme drawers/cart (body[scroll-y-off])
 * - Judge.me review image lightbox (body.jm-mfp-is-open + position:fixed lock)
 */
(function () {
  'use strict';

  var lockY = 0;
  var restoreUntil = 0;
  var judgemeWasOpen = false;
  var OVERLAY_IDS = ['CartDrawer', 'DrawerMenu', 'CDrawerMenu'];

  function readLockYFromBody() {
    var top = document.body && document.body.style && document.body.style.top;
    if (!top) return 0;
    return Math.abs(parseInt(top, 10) || 0);
  }

  function isJudgemeLightboxOpen() {
    return !!(document.body && document.body.classList && document.body.classList.contains('jm-mfp-is-open'));
  }

  function isBodyScrollLocked() {
    return (
      document.body.hasAttribute('scroll-y-off') ||
      isJudgemeLightboxOpen() ||
      (document.body.style.position === 'fixed' && !!document.body.style.top)
    );
  }

  function captureLockY() {
    var fromBody = readLockYFromBody();
    if (fromBody > 0) {
      lockY = fromBody;
      return;
    }
    var fromWindow = window.pageYOffset != null ? window.pageYOffset : window.scrollY;
    if (fromWindow > 0) {
      lockY = fromWindow;
    }
  }

  function extractScrollToY(args) {
    if (!args || !args.length) return null;
    var first = args[0];
    if (first && typeof first === 'object') {
      return typeof first.top === 'number' ? first.top : null;
    }
    if (args.length > 1 && typeof args[1] === 'number') {
      return args[1];
    }
    return null;
  }

  function scrollToInstant(y) {
    if (typeof y !== 'number' || y < 0) return;
    var root = document.documentElement;
    var prevRoot = root.style.scrollBehavior;
    var prevBody = document.body.style.scrollBehavior;
    root.style.scrollBehavior = 'auto';
    document.body.style.scrollBehavior = 'auto';
    try {
      window.__overlayScrollLockOrigScrollTo({ top: y, left: 0, behavior: 'instant' });
    } catch (e) {
      window.__overlayScrollLockOrigScrollTo(0, y);
    }
    root.style.scrollBehavior = prevRoot;
    document.body.style.scrollBehavior = prevBody;
  }

  function beginRestore() {
    if (lockY < 1) return;
    restoreUntil = Date.now() + 800;
    document.documentElement.classList.add('overlay-scroll-restoring');
    scrollToInstant(lockY);
    if (window.requestAnimationFrame) {
      requestAnimationFrame(function () {
        scrollToInstant(lockY);
        requestAnimationFrame(function () {
          scrollToInstant(lockY);
        });
      });
    }
    window.setTimeout(function () {
      scrollToInstant(lockY);
    }, 0);
    window.setTimeout(function () {
      scrollToInstant(lockY);
      document.documentElement.classList.remove('overlay-scroll-restoring');
    }, 400);
  }

  function isOverlaySidebarButton(el) {
    if (!el || !el.getAttribute) return false;
    var sidebarId = el.getAttribute('data-sidebar-id');
    return el.hasAttribute('data-sidebar-button') && OVERLAY_IDS.indexOf(sidebarId) !== -1;
  }

  function isOverlayFocusTarget(el) {
    if (!el) return false;
    if (el.id === 'DrawerMenuToggler') return true;
    if (el.id && OVERLAY_IDS.indexOf(el.id) !== -1) return true;
    if (el.tagName === 'DRAWER-MENU') return true;
    if (el.classList && el.classList.contains('hamburger')) return true;
    return false;
  }

  function shouldPreventScrollFocus(el) {
    return isOverlaySidebarButton(el) || isOverlayFocusTarget(el);
  }

  function installStyle() {
    if (document.getElementById('overlay-scroll-lock-fix-style')) return;
    var style = document.createElement('style');
    style.id = 'overlay-scroll-lock-fix-style';
    style.textContent =
      'html.overlay-scroll-restoring, html.overlay-scroll-restoring * { scroll-behavior: auto !important; }';
    (document.head || document.documentElement).appendChild(style);
  }

  window.__overlayScrollLockOrigScrollTo = window.scrollTo.bind(window);
  window.scrollTo = function () {
    var y = extractScrollToY(arguments);
    var isRestore =
      lockY > 0 &&
      (Date.now() < restoreUntil ||
        (!isBodyScrollLocked() && typeof y === 'number' && Math.abs(y - lockY) < 4));

    if (isRestore) {
      scrollToInstant(typeof y === 'number' ? y : lockY);
      return;
    }

    return window.__overlayScrollLockOrigScrollTo.apply(window, arguments);
  };

  if (window.HTMLElement && window.HTMLElement.prototype) {
    var origFocus = window.HTMLElement.prototype.focus;
    window.HTMLElement.prototype.focus = function (opts) {
      if (shouldPreventScrollFocus(this)) {
        try {
          if (!opts) {
            return origFocus.call(this, { preventScroll: true });
          }
          if (typeof opts === 'object' && opts.preventScroll == null) {
            return origFocus.call(this, Object.assign({}, opts, { preventScroll: true }));
          }
        } catch (err) {
          return origFocus.call(this, opts);
        }
      }
      return origFocus.call(this, opts);
    };
  }

  document.addEventListener(
    'click',
    function (event) {
      var trigger = event.target && event.target.closest
        ? event.target.closest(
            '#DrawerMenuToggler, [data-sidebar-id="DrawerMenu"], [data-sidebar-id="CDrawerMenu"], [data-sidebar-id="CartDrawer"], .jdgm-rev__pic-link, .jdgm-gallery, .jdgm-rev__pics, .jdgm-rev img'
          )
        : null;
      if (!trigger || isBodyScrollLocked()) return;
      var y = window.pageYOffset != null ? window.pageYOffset : window.scrollY;
      if (y > 0) lockY = y;
    },
    true
  );

  var bodyMo = new MutationObserver(function (mutations) {
    for (var i = 0; i < mutations.length; i++) {
      var mutation = mutations[i];

      if (mutation.attributeName === 'scroll-y-off') {
        if (document.body.hasAttribute('scroll-y-off')) {
          captureLockY();
          if (window.requestAnimationFrame) {
            requestAnimationFrame(captureLockY);
          }
        } else {
          beginRestore();
        }
        continue;
      }

      if (mutation.attributeName === 'class') {
        var isOpen = isJudgemeLightboxOpen();
        if (isOpen && !judgemeWasOpen) {
          judgemeWasOpen = true;
          captureLockY();
          if (window.requestAnimationFrame) {
            requestAnimationFrame(captureLockY);
          }
        } else if (!isOpen && judgemeWasOpen) {
          judgemeWasOpen = false;
          captureLockY();
          beginRestore();
        }
        continue;
      }

      if (mutation.attributeName === 'style' && isBodyScrollLocked()) {
        captureLockY();
      }
    }
  });

  function boot() {
    installStyle();
    if (!document.body) return;
    judgemeWasOpen = isJudgemeLightboxOpen();
    try {
      bodyMo.observe(document.body, {
        attributes: true,
        attributeFilter: ['scroll-y-off', 'style', 'class'],
      });
    } catch (e) {}
    if (isBodyScrollLocked()) {
      captureLockY();
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
